// extracted by mini-css-extract-plugin
export var checkboxInputRow = "t_rz";
export var checkboxInputColumn = "t_rB";
export var inputOptionRow = "t_qf";
export var inputOptionColumn = "t_qg";